import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const BASE_URL = process.env.API_URL + '/admin'

const YoutubeBannerService = {
  actions: {
    fetchAllYoutubeBanners ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/youtube-banners',
          method: 'GET'
        })
          .then(resp => {
            const youtubeBanners = resp.data.youtube_banners
            commit('api_success')
            resolve(resp)
            return youtubeBanners
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    createYoutubeBanner ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/youtube-banner',
          data: data,
          method: 'POST'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            commit('api_error')
            reject(err)
          })
      })
    },
    deleteYoutubeBanner ({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/youtube-banner/' + id,
          method: 'delete'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            commit('api_error')
            reject(err)
          })
      })
    },
    editYoutubeBanner ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/youtube-banner/' + data.get('id'),
          data: data,
          method: 'POST'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            commit('api_error')
            reject(err)
          })
      })
    },
    fetchYoutubeBanner ({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/youtube-banner/' + id,
          method: 'GET'
        })
          .then(resp => {
            const youtubeBanner = resp.data.youtubeBanner
            commit('api_success')
            resolve(resp)
            return youtubeBanner
          })
          .catch(err => {
            commit('api_error')
            reject(err)
          })
      })
    }
  }
}

export default YoutubeBannerService



// WEBPACK FOOTER //
// ./src/services/youtubeBannerService.js